import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { newId } from '../data/ids.js';

const DEVICE_KEY = 'cadencia.deviceId';

export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

export function platformName(): string {
  return Capacitor.getPlatform();
}

/**
 * Identificador estable del dispositivo. Se usa para el desempate determinista
 * de conflictos y para la trazabilidad del origen de cada escritura.
 * No identifica al usuario ni sale nunca hacia la IA.
 */
export async function getDeviceId(): Promise<string> {
  if (isNativePlatform()) {
    const stored = await Preferences.get({ key: DEVICE_KEY });
    if (stored.value) return stored.value;
    const fresh = `and-${newId()}`;
    await Preferences.set({ key: DEVICE_KEY, value: fresh });
    return fresh;
  }

  const stored = globalThis.localStorage?.getItem(DEVICE_KEY);
  if (stored) return stored;
  const fresh = `web-${newId()}`;
  globalThis.localStorage?.setItem(DEVICE_KEY, fresh);
  return fresh;
}
